import * as React from 'react';

export interface IHistoricalTableAngler {
  FishermenId: number;
  City: string;
  state: string;
  final_weight: number;
  PRIZE_MONEY: number;
  merchandise_bonus: number;
  cash_bonus: number;
  place: number;
  Title: string;
  State: string;
  Water: string;
  URL: string;
}

export interface IHistoricalTableRow {
  Tournament: React.ReactNode;
  Location: React.ReactNode;
  Place: React.ReactNode;
  'Total Weight': React.ReactNode;
  'Cash Winnings': React.ReactNode;
  'Merchandise Bonus': React.ReactNode;
  'Cash Bonus': React.ReactNode;
  'Total Money': React.ReactNode;
}

export enum HistoricalTableTypes {
  CLASSIC = 'classic',
  CLASSIC_WINS = 'classicwins',
  MONEY = 'money',
  FIRST = 'first',
  SECOND = 'second',
  THIRD = 'third',
  TOP_10 = 'top10',
  TOP_20 = 'top20',
  TOP_30 = 'top30',
}
